import { render } from "./ListEvent.vue?vue&type=template&id=15750d8c&scoped=true"
import script from "./ListEvent.vue?vue&type=script&lang=js"
export * from "./ListEvent.vue?vue&type=script&lang=js"

import "./ListEvent.vue?vue&type=style&index=0&id=15750d8c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15750d8c"]])

export default __exports__